import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Router} from '../../routes'
import HoverIntent from 'react-hoverintent'

import ModalLink from '../links/ModalLink'
import RouterLink from '../links/RouterLink'

import VideoWindow from "../windows/VideoWindow";
import withDeviceContext from '../WithDeviceContext'

momentDurationFormatSetup(Moment)

class Video extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mouseover: false,
            showVideo: false
        }
        this.onMouseOver = this.onMouseOver.bind(this)
        this.onMouseOut = this.onMouseOut.bind(this)
        this.play =  this.play.bind(this)
    }

    duration() {
        if(this.state.showVideo) {
            return null;
        }
        let duration = Moment.duration(this.props.duration, "seconds").format('H:mm:ss');
        return <span className="duration">{duration}</span>
    }

    onMouseOver() {
        this.setState({mouseover: true})
    }

    onMouseOut() {
        this.setState({showVideo: false, mouseover: false})
    }
    play() {
        this.setState({showVideo: true})
    }

    static urlize(str) {
        return str.toLocaleLowerCase().replace(/\s+/g, '-')
    }

    static url(id, title) {
        let urlized = Video.urlize(title)
        return `/videos/${id}/${urlized}`
    }

    video() {
        if (!this.state.mouseover || !this.props.vthumb) {
            return null;
        } else {
            let vClass = this.state.showVideo ? "thevideo" : "thevideo hidden";
            let url = this.props.vthumb["link"]
            return <video onPlay={this.play} className={vClass} loop autoPlay>
                <source src={url} type="video/mp4" />
            </video>
        }
    }

    vThumb() {
        let imgClass = this.state.showVideo ? "theimg hidden" : "theimg";
        const {title, backpage, thumb, id} = this.props

        let linkProps = {title, backpage}

        if(this.props.device === 'mobile' || this.props.device === 'tablet') {
            var el = RouterLink
            linkProps.route = "video"
            linkProps.params = {video_id: id, title: Video.urlize(title)}

        } else {
            el = ModalLink
            linkProps.url = Video.url(id, title)
            linkProps.componentClass = VideoWindow
            linkProps.componentParams = {video_id: id}
        }


        return React.createElement(el, linkProps,
            <div className="img-holder">
                <div className="inner">
                    {this.duration()}
                    <img className={imgClass} src={thumb}/>
                    {this.video()}
                </div>
            </div>,
            <strong className="thumb-title">{title}</strong>
        )
    }
    render() {
        const {id} = this.props

        return (
            <HoverIntent onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut} sensitivity={10} timeout={250}>
                <div className="item col-lg-2 col-md-3 col-xs-12" key={id}>
                    {this.vThumb()}
                </div>
            </HoverIntent>
        )
    }
}

export default connect()(withDeviceContext(Video))



// WEBPACK FOOTER //
// components/thumbs/Video.js